// extracted by mini-css-extract-plugin
export default {"quickLink":"QuickLink_quickLink__GzoDv","disableLink":"QuickLink_disableLink__z-4g7"};